module.exports = __webpack_public_path__ + "static/media/dec-thumb-help-regions-large.7b426294.png";